import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IFileUploadStatus } from '../../../models/fileUpload';
import { Button, SpinnerIcon } from '@/lib';
import CloseIcon from '@/assets/icons/close.svg?react';

interface IUploadingStatus {
  fileUpload: IFileUploadStatus;
  handleCancel: () => void;
}

export const UploadingStatus: FC<IUploadingStatus> = ({ fileUpload, handleCancel }) => {
  const [isCancelClicked, setCancelClicked] = useState(false);

  const { t } = useTranslation('data_source_edit');

  return (
    <div className='flex h-52 flex-col items-center justify-center gap-6 rounded-md border bg-blue-50 p-6 motion-safe:transition motion-safe:duration-500 motion-reduce:transition-none'>
      {isCancelClicked ? (
        <>
          <CloseIcon className='text-blue-900' />
          <p className='text-xl font-medium text-blue-900'>{t('file.name_and_file.file_upload_input_component.cancel_upload')}</p>
          <div className='flex gap-2'>
            <Button intent='primary' className='border' onClick={handleCancel}>
              {t('file.name_and_file.file_upload_input_component.delete_file')}
            </Button>
            <Button intent='secondary' onClick={() => setCancelClicked(false)}>
              {t('file.name_and_file.file_upload_input_component.resume_upload')}
            </Button>
          </div>
        </>
      ) : (
        <>
          <SpinnerIcon className='size-8 text-blue-900' />
          <p className='text-xl font-medium text-blue-900'>
            {`${t('file.name_and_file.file_upload_input_component.uploading')} ${fileUpload.percentage.percentageCompleted} %`}
          </p>
          <Button intent='primary' onClick={() => setCancelClicked(true)}>
            {t('file.name_and_file.file_upload_input_component.cancel_upload')}
          </Button>
        </>
      )}
    </div>
  );
};
